import React from "react";

/**
 * The site is printed on a sheet. The closing chapter sits underneath it and is
 * uncovered as the sheet scrolls away — pure stacking order plus a spacer, so
 * nothing is pinned and scrolling is never hijacked.
 *
 * The spacer carries the chapter id: it lives in normal flow, so anchor
 * navigation and the rail's ScrollTriggers resolve against a real position
 * instead of a fixed element.
 */
const Sheet = ({ children, footer, revealId }) => (
  <div className="relative">
    <div
      className="relative z-content"
      style={{ background: "var(--bg)", boxShadow: "0 1px 0 0 var(--flare)" }}
    >
      {children}
    </div>

    <div id={revealId} data-reveal-spacer style={{ height: "100svh" }} />

    <div className="fixed inset-x-0 bottom-0 z-0" style={{ height: "100svh" }}>
      {footer}
    </div>
  </div>
);

export default Sheet;
